import { cn, stateTone, toneText, type Tone } from '../cn';

export interface StatusPillProps {
  children: React.ReactNode;
  tone?: Tone;
  /** Shorthand: derive the tone from a device state (live/standby/offline/locked). */
  state?: string;
  className?: string;
  size?: 'xs' | 'sm';
}

/** Text-only mono status: 500 10px/1, .08em, nowrap, flex-none (design `stTxt`). */
export function StatusPill({ children, tone, state, className, size = 'xs' }: StatusPillProps) {
  const t = tone ?? (state ? stateTone(state) : 'fg3');
  return (
    <span className={cn('flex-none whitespace-nowrap font-mono font-medium uppercase leading-none tracking-micro', size === 'xs' ? 'text-xs' : 'text-sm', toneText[t], className)}>
      {children}
    </span>
  );
}
